import { render } from "./StatsBuilderCol.vue?vue&type=template&id=59cc749e"
import script from "./StatsBuilderCol.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderCol.vue?vue&type=script&lang=ts"

import "./StatsBuilderCol.vue?vue&type=style&index=0&id=59cc749e&lang=scss"
script.render = render

export default script